export const ArticlesColumns = [
    {
        name: 'Заголовок',
        key: 'title',
    },
    {
        name: 'Дата создания',
        key: 'created_at'
    },
    {
        name: 'Просмотров',
        key: 'showsCount'
    },
    {
        name: 'Рейтинг',
        key: 'rating'
    }
]